import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=e4936436&"
import script from "./Color.vue?vue&type=script&lang=ts&"
export * from "./Color.vue?vue&type=script&lang=ts&"
import style0 from "./Color.vue?vue&type=style&index=0&id=e4936436&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports